import {
  Slider as ChakraSlider,
  Flex,
  Box,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
} from "@chakra-ui/react";
import Text from "components/base/Text";

const Slider = ({ label, valueLabel, pt, isReadOnly, ...props }) => (
  <Box>
    <Flex
      pt={pt || "md"}
      pb="xxs"
      justify="space-between"
      align="center"
      mb={isReadOnly ? "-12px" : 0}
    >
      <Text type="p_sm" fontWeight="bold" color="black.700">
        {label}
      </Text>
      <Text type="p_sm" fontWeight="bold" color="black.700">
        {valueLabel}
      </Text>
    </Flex>
    <ChakraSlider size="lg" isReadOnly={isReadOnly} {...props}>
      <SliderTrack bg="gray.300">
        <SliderFilledTrack bg={isReadOnly ? "gray.400" : "primaryNeon"} />
      </SliderTrack>
      {!isReadOnly && <SliderThumb />}
    </ChakraSlider>
  </Box>
);

export default Slider;
